
<template>
  <!-- <transition name="badgeIn"> -->
  <div class="badge">
    <div class="content">
      <div :class="['badge__top',hasBadge?'':'badge__no']">
        <p>{{hasBadge?'你获得了':'非常遗憾'}}</p>
        <p>{{hasBadge?(badgeData.badge.badge_name||'')+'徽章':'继续努力，下次还有机会'}}</p>
        <div v-if="hasBadge" class="imgbox">
          <div class="circlebox">
            <img class="circle" src="../../../assets/img/video/circle01.png" alt>
            <img class="circle" src="../../../assets/img/video/circle02.png" alt>
            <img class="circle" src="../../../assets/img/video/circle03.png" alt>
            <img
              class="badge__img"
              :src="badgeData.badge.avatar_url||require('../../../assets/img/video/badge_error.png')" alt="徽章显示异常"
            >
          </div>
        </div>
        <img class="badge__img" v-else src="../../../assets/img/video/badge_no.png">
      </div>
      <div class="badeg__bottom">
        <img
          v-if="hasBadge"
          class="badge__shadow"
          src="../../../assets/img/video/badge_shadow.png"
          alt="阴影"
        >
        <p class="title">
          <span class="line"></span>
          <span
            class="className"
          >{{smallClassName | realSubstring(16)}}获奖名单</span>
          <span class="line"></span>
        </p>
        <div class="list">
          <div class="pagebox" :style="{left:moveleft+'px','transition-duration': moveTime+'s' }">
            <div class="page" v-for="(item,index) in source" :key="index">
              <span
                :style="{color:item1.id==userID? '#f57f22':''}"
                v-for="(item1,index) in item"
                :key="index"
              >{{item1.name | realSubstring(8,'...')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div :class="[animationReset?'animationReset':'']">
        <div
          :style="{transform:'rotate('+ Math.floor(Math.random()*100)+ 'deg)'}"
          class="area area1">
          <!--  往左上飞出距离较长 -->
          <img
            class="particle fraction2 outer"
            src="../../../assets/img/video/2.png"
            style="top:-4%; left:126%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction5 outer"
            src="../../../assets/img/video/4.png"
            style="top:153%; left:106%;width:10px; height:15px;"
          >
          
          <img
            class="particle fraction6 outer"
            src="../../../assets/img/video/5.png"
            style="top:25%; left:134%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction8 outer"
            src="../../../assets/img/video/1.png"
            style="top:25%; left:-15%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction9 outer"
            src="../../../assets/img/video/7.png"
            style="top:99%; left:122%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction10 outer"
            src="../../../assets/img/video/5.png"
            style="top:-20%; left:56%;width:8px; height:12px;"
          >
          <img
            class="particle fraction11 outer"
            src="../../../assets/img/video/4.png"
            style="top:0%; left:64%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction12 outer"
            src="../../../assets/img/video/2.png"
            style="top:138%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction13 outer"
            src="../../../assets/img/video/1.png"
            style="top:18%; left:109%;width:13px; height:15px;"
          >
          <img
            class="particle fraction14 outer"
            src="../../../assets/img/video/2.png"
            style="top:-10%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction15 outer"
            src="../../../assets/img/video/4.png"
            style="top:61%; left:143%;width:12px; height:15px;"
          >
          <img
            class="particle fraction16 outer"
            src="../../../assets/img/video/5.png"
            style="top:0%; left:-4%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction17 outer"
            src="../../../assets/img/video/4.png"
            style="top:126%; left:-4%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction20 outer"
            src="../../../assets/img/video/7.png"
            style="top:87%; left:-26%;width:15px; height:12px;"
          >
          
          <img
            class="particle fraction22 outer"
            src="../../../assets/img/video/4.png"
            style="top:58%; left:-31%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction23 outer"
            src="../../../assets/img/video/2.png"
            style="top:128%; left:47%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction25 outer"
            src="../../../assets/img/video/4.png"
            style="top:86%; left:75%;width:11px; height:15px;"
          >
          <img
            class="particle fraction26 outer"
            src="../../../assets/img/video/5.png"
            style="top:151%; left:45%;width:8px; height:13px;"
          >
          <img
            class="particle fraction27 outer"
            src="../../../assets/img/video/6.png"
            style="top:162%; left:70%;width:10px; height:13px;"
          >
          <img
            class="particle fraction28 outer"
            src="../../../assets/img/video/7.png"
            style="top:127%; left:20%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction29 outer"
            src="../../../assets/img/video/8.png"
            style="top:-5%; left:20%;width:12px; height:13px;"
          >
          
          <img
            class="particle fraction31 outer"
            src="../../../assets/img/video/6.png"
            style="top:152%; left:8%;width:13px; height:15px;"
          >
          <img
            class="particle fraction32 outer"
            src="../../../assets/img/video/5.png"
            style="top:23%; left:74%;width:10px; height:13px;"
          >
          <img
            class="particle fraction33 outer"
            src="../../../assets/img/video/4.png"
            style="top:124%; left:130%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction40 outer"
            src="../../../assets/img/video/3.png"
            style="top:139%; left:-26%;width:12px; height:11px;"
          >

          <!--内圈开始-->
          <img
            class="particle fraction19 inner"
            src="../../../assets/img/video/7.png"
            style="top:81%; left:-8%;width:16px; height:14px;"
          >
          <img
            class="particle fraction36 inner"
            src="../../../assets/img/video/2.png"
            style="top:68%; left:-6%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction38 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:13px; height:15px;"
          >
          <img
            class="particle fraction30 inner"
            src="../../../assets/img/video/7.png"
            style="top:18%; left:38%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction21 inner"
            src="../../../assets/img/video/5.png"
            style="top:105%; left:79%;width:8px; height:14px;"
          >
          <img
            class="particle fraction24 inner"
            src="../../../assets/img/video/2.png"
            style="top:102%; left:20%;width:12px; height:12px;"
          >
          <img
            class="particle fraction34 inner"
            src="../../../assets/img/video/2.png"
            style="top:33%; left:102%;width:12px; height:6px;"
          >
          <img
            class="particle fraction35 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:12px; height:15px;"
          >
        </div>
        <div
          :style="{transform:'rotate('+ Math.floor(Math.random()*100)+ 'deg)'}"
          class="area area2"
        >
          <!--  往左上飞出距离较长 -->
          <img
            class="particle fraction2 outer"
            src="../../../assets/img/video/2.png"
            style="top:-4%; left:126%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction5 outer"
            src="../../../assets/img/video/4.png"
            style="top:153%; left:106%;width:10px; height:15px;"
          >
          
          <img
            class="particle fraction6 outer"
            src="../../../assets/img/video/5.png"
            style="top:25%; left:134%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction8 outer"
            src="../../../assets/img/video/1.png"
            style="top:25%; left:-15%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction9 outer"
            src="../../../assets/img/video/7.png"
            style="top:99%; left:122%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction10 outer"
            src="../../../assets/img/video/5.png"
            style="top:-20%; left:56%;width:8px; height:12px;"
          >
          <img
            class="particle fraction11 outer"
            src="../../../assets/img/video/4.png"
            style="top:0%; left:64%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction12 outer"
            src="../../../assets/img/video/2.png"
            style="top:138%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction13 outer"
            src="../../../assets/img/video/1.png"
            style="top:18%; left:109%;width:13px; height:15px;"
          >
          <img
            class="particle fraction14 outer"
            src="../../../assets/img/video/2.png"
            style="top:-10%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction15 outer"
            src="../../../assets/img/video/4.png"
            style="top:61%; left:143%;width:12px; height:15px;"
          >
          <img
            class="particle fraction16 outer"
            src="../../../assets/img/video/5.png"
            style="top:0%; left:-4%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction17 outer"
            src="../../../assets/img/video/4.png"
            style="top:126%; left:-4%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction20 outer"
            src="../../../assets/img/video/7.png"
            style="top:87%; left:-26%;width:15px; height:12px;"
          >
          
          <img
            class="particle fraction22 outer"
            src="../../../assets/img/video/4.png"
            style="top:58%; left:-31%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction23 outer"
            src="../../../assets/img/video/2.png"
            style="top:128%; left:47%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction25 outer"
            src="../../../assets/img/video/4.png"
            style="top:86%; left:75%;width:11px; height:15px;"
          >
          <img
            class="particle fraction26 outer"
            src="../../../assets/img/video/5.png"
            style="top:151%; left:45%;width:8px; height:13px;"
          >
          <img
            class="particle fraction27 outer"
            src="../../../assets/img/video/6.png"
            style="top:162%; left:70%;width:10px; height:13px;"
          >
          <img
            class="particle fraction28 outer"
            src="../../../assets/img/video/7.png"
            style="top:127%; left:20%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction29 outer"
            src="../../../assets/img/video/8.png"
            style="top:-5%; left:20%;width:12px; height:13px;"
          >
          
          <img
            class="particle fraction31 outer"
            src="../../../assets/img/video/6.png"
            style="top:152%; left:8%;width:13px; height:15px;"
          >
          <img
            class="particle fraction32 outer"
            src="../../../assets/img/video/5.png"
            style="top:23%; left:74%;width:10px; height:13px;"
          >
          <img
            class="particle fraction33 outer"
            src="../../../assets/img/video/4.png"
            style="top:124%; left:130%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction40 outer"
            src="../../../assets/img/video/3.png"
            style="top:139%; left:-26%;width:12px; height:11px;"
          >

          <!--内圈开始-->
          <img
            class="particle fraction19 inner"
            src="../../../assets/img/video/7.png"
            style="top:81%; left:-8%;width:16px; height:14px;"
          >
          <img
            class="particle fraction36 inner"
            src="../../../assets/img/video/2.png"
            style="top:68%; left:-6%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction38 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:13px; height:15px;"
          >
          <img
            class="particle fraction30 inner"
            src="../../../assets/img/video/7.png"
            style="top:18%; left:38%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction21 inner"
            src="../../../assets/img/video/5.png"
            style="top:105%; left:79%;width:8px; height:14px;"
          >
          <img
            class="particle fraction24 inner"
            src="../../../assets/img/video/2.png"
            style="top:102%; left:20%;width:12px; height:12px;"
          >
          <img
            class="particle fraction34 inner"
            src="../../../assets/img/video/2.png"
            style="top:33%; left:102%;width:12px; height:6px;"
          >
          <img
            class="particle fraction35 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:12px; height:15px;"
          >
        </div>
        <div
          :style="{transform:'rotate('+ Math.floor(Math.random()*100)+ 'deg)'}"
          class="area area3"
        >
          <!--  往左上飞出距离较长 -->
          <img
            class="particle fraction2 outer"
            src="../../../assets/img/video/2.png"
            style="top:-4%; left:126%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction5 outer"
            src="../../../assets/img/video/4.png"
            style="top:153%; left:106%;width:10px; height:15px;"
          >
          
          <img
            class="particle fraction6 outer"
            src="../../../assets/img/video/5.png"
            style="top:25%; left:134%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction8 outer"
            src="../../../assets/img/video/1.png"
            style="top:25%; left:-15%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction9 outer"
            src="../../../assets/img/video/7.png"
            style="top:99%; left:122%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction10 outer"
            src="../../../assets/img/video/5.png"
            style="top:-20%; left:56%;width:8px; height:12px;"
          >
          <img
            class="particle fraction11 outer"
            src="../../../assets/img/video/4.png"
            style="top:0%; left:64%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction12 outer"
            src="../../../assets/img/video/2.png"
            style="top:138%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction13 outer"
            src="../../../assets/img/video/1.png"
            style="top:18%; left:109%;width:13px; height:15px;"
          >
          <img
            class="particle fraction14 outer"
            src="../../../assets/img/video/2.png"
            style="top:-10%; left:81%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction15 outer"
            src="../../../assets/img/video/4.png"
            style="top:61%; left:143%;width:12px; height:15px;"
          >
          <img
            class="particle fraction16 outer"
            src="../../../assets/img/video/5.png"
            style="top:0%; left:-4%;width:8px; height:12px;"
          >
          
          <img
            class="particle fraction17 outer"
            src="../../../assets/img/video/4.png"
            style="top:126%; left:-4%;width:11px; height:15px;"
          >
          
          <img
            class="particle fraction20 outer"
            src="../../../assets/img/video/7.png"
            style="top:87%; left:-26%;width:15px; height:12px;"
          >
          
          <img
            class="particle fraction22 outer"
            src="../../../assets/img/video/4.png"
            style="top:58%; left:-31%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction23 outer"
            src="../../../assets/img/video/2.png"
            style="top:128%; left:47%;width:12px; height:8px;"
          >
          
          <img
            class="particle fraction25 outer"
            src="../../../assets/img/video/4.png"
            style="top:86%; left:75%;width:11px; height:15px;"
          >
          <img
            class="particle fraction26 outer"
            src="../../../assets/img/video/5.png"
            style="top:151%; left:45%;width:8px; height:13px;"
          >
          <img
            class="particle fraction27 outer"
            src="../../../assets/img/video/6.png"
            style="top:162%; left:70%;width:10px; height:13px;"
          >
          <img
            class="particle fraction28 outer"
            src="../../../assets/img/video/7.png"
            style="top:127%; left:20%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction29 outer"
            src="../../../assets/img/video/8.png"
            style="top:-5%; left:20%;width:12px; height:13px;"
          >
          
          <img
            class="particle fraction31 outer"
            src="../../../assets/img/video/6.png"
            style="top:152%; left:8%;width:13px; height:15px;"
          >
          <img
            class="particle fraction32 outer"
            src="../../../assets/img/video/5.png"
            style="top:23%; left:74%;width:10px; height:13px;"
          >
          <img
            class="particle fraction33 outer"
            src="../../../assets/img/video/4.png"
            style="top:124%; left:130%;width:12px; height:15px;"
          >
          
          <img
            class="particle fraction40 outer"
            src="../../../assets/img/video/3.png"
            style="top:139%; left:-26%;width:12px; height:11px;"
          >

          <!--内圈开始-->
          <img
            class="particle fraction19 inner"
            src="../../../assets/img/video/7.png"
            style="top:81%; left:-8%;width:16px; height:14px;"
          >
          <img
            class="particle fraction36 inner"
            src="../../../assets/img/video/2.png"
            style="top:68%; left:-6%;width:13px; height:8px;"
          >
          
          <img
            class="particle fraction38 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:13px; height:15px;"
          >
          <img
            class="particle fraction30 inner"
            src="../../../assets/img/video/7.png"
            style="top:18%; left:38%;width:15px; height:13px;"
          >
          
          <img
            class="particle fraction21 inner"
            src="../../../assets/img/video/5.png"
            style="top:105%; left:79%;width:8px; height:14px;"
          >
          <img
            class="particle fraction24 inner"
            src="../../../assets/img/video/2.png"
            style="top:102%; left:20%;width:12px; height:12px;"
          >
          <img
            class="particle fraction34 inner"
            src="../../../assets/img/video/2.png"
            style="top:33%; left:102%;width:12px; height:6px;"
          >
          <img
            class="particle fraction35 inner"
            src="../../../assets/img/video/1.png"
            style="top:23%; left:-7%;width:12px; height:15px;"
          >
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "badge",
  data() {
    return {
      showRight: false, //展示右边的动画,
      badgeList: null,
      interval: null,
      moveleft: 0,
      moveTime: 1.1,
      source: [],
      animationReset: false
    };
  },
  created() {},
  computed: {
    ...mapState(["smallClassName", "userID"]),
    hasBadge() {
      return this.badgeData.awarded == 1;
    }
  },
  mounted() {
    this.getgroups();
    if (this.badgeData.awarded == 1) {
      setInterval(() => {
        this.animationReset = true;
      }, 1300);
      setInterval(() => {
        this.animationReset = false;
      }, 5000);
    }

    setTimeout(() => {
      this.$emit("badgeCallback");
    }, 30000);
  },
  props: {
    badgeData: {
      type: Object,
      required: true
    }
  },
  methods: {
    startScroll() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.moveleft -= 410;
        this.moveTime = 1.1;
        if (Math.abs(this.moveleft) / 410 == this.source.length) {
          this.moveleft = 0;
          this.moveTime = 0;
          setTimeout(() => {
            this.moveleft = -410;
            this.moveTime = 1.1;
          }, 100);
        }
      }, 5000);
    },
    getgroups() {
      this.badgeList = this.badgeData.students_list;

      let result = [];
      while (true) {
        if (this.badgeList.length > 12) {
          result.push(this.badgeList.splice(0, 12));
        } else {
          result.push(this.badgeList);
          break;
        }
      }
      this.source = result.length > 1 ? [...result, result[0]] : result;
      if (this.source.length > 1) {
        setTimeout(() => {
          this.startScroll();
        }, 3000);
      }
    }
  },
  destroyed() {
    //("徽章显示30s后成功关闭");
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less" scoped>
.badge {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 81;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 490px;
    height: 580px;
    border-radius: 15px;
    position: relative;
    .badge__top {
      padding-top: 32px;
      height: 354px;
      background:#00708F url("../../../assets/img/video/badge_bg_success.png")
        no-repeat center / 100%;
      border-radius: 15px 15px 0 0;
      //  background: #fff;
      color: #fff;
      p {
        font-family: PingFang-Regular;
        font-size: 18px;
        line-height: 18px;
        &:nth-of-type(2) {
          font-family: PingFang_Medium;
          font-size: 24px;
          line-height: 24px;
          margin-top: 10px;
        }
      }
      .imgbox {
        height: 270px;
        text-align: center;
        padding-top: 20px;
        .circlebox {
          display: inline-block;
          position: relative;
          // background: red;
          width: 367px;
          height: 100%;
          .circle {
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            &:nth-child(1) {
              width: 240px;
              animation: badgecircle.8s 0.5s ease-in backwards;
            }
            &:nth-child(2) {
              animation: badgecircle 0.5s 0.7s ease-in backwards;
              width: 290px;
            }
            &:nth-child(3) {
              animation: badgecircle 0.9s ease-in backwards;
              width: 340px;
            }
          }
          .badge__img {
            position: absolute;
            width: 230px;
            height: 230px;
            bottom: 4px;
            margin-left: -115px;
            left: 50%;
            animation: badgeImg 1s 0.7s ease-in-out;
            animation-fill-mode: both;
          }
        }
      }
    }
    .badge__no {
      padding-top: 52px;
      background: #B6DAE4 url("../../../assets/img/video/badge_bg_fail.png") no-repeat
        center / 100%;
      border-radius: 15px 15px 0 0;
      p {
        font-family: PingFang_Medium;
        font-size: 32px;
        color: #003057;
        line-height: 32px;
        &:nth-of-type(2) {
          margin-top: 12px;
          font-family: PingFang_Regular;
          font-size: 18px;
          color: #003057;
          line-height: 18px;
        }
      }
      .badge__img {
        margin-top: 37px;
        width: 333px;
      }
    }
    .badeg__bottom {
      padding-top: 10px;
      height: 226px;
      background: #f4f4f6;
      border-radius: 0 0 15px 15px;
      text-align: center;
      .badge__shadow {
        height: 14px;
        width: 201px;
        animation: badgeshadow 1s 0.7s cubic-bezier(0.745, 0, 0.31, 0.995);
        animation-fill-mode: both;
        animation: name duration timing-function delay iteration-count direction
          fill-mode;
      }
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        .className {
          font-family: PingFang_Medium;
          font-size: 20px;
          color: #007a9c;
          line-height: 20px;
          margin: 0 8px;
        }
        .line {
          margin: 0;
          background: #d0d0d1;
          height: 1px;
          display: inline-block;
          width: 24px;
        }
      }
      .list {
        display: inline-block;
        margin-top: 20px;
        height: 96px;
        width: 410px;
        overflow: hidden;
        position: relative;
        .pagebox {
          transition-timing-function: ease-in-out;
          height: 96px;
          display: inline-flex;
          position: absolute;
          left: 0px;
          .page {
            width: 410px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            span {
              width: 25%;
              font-family: PingFang_Regular;
              font-size: 16px;
              color: #003057;
              line-height: 32px;
              text-align: left;
            }
          }
        }
      }
    }
    .area {
      width: 200px;
      height: 200px;
      position: absolute;

      z-index: 80;
      .particle {
        opacity: 0;
        position: absolute;
        transform: scale(0.8);
      }
    }
    .area1 {
      top: -4%;
      left: 1%;
    }
    .area2 {
      left: 64%;
      top: 33%;
    }
    .area3 {
      top: 54%;
      left: 2%;
    }
  }

  /*粒子动画*/

  .animationReset {
    
    .area1 {
      .outer {
        animation: aaa 0.6s 0.2s ease-in-out;
      }
      .inner {
        animation: aaa 0.5s ease-in-out;
      }
    }
    .area2 {
      .outer {
        animation: aaa 0.6s 0.6s ease-in-out;
      }
      .inner {
        animation: aaa 0.5s 0.4s ease-in-out;
      }
    }
    .area3 {
      .outer {
        animation: aaa 0.6s 1.1s ease-in-out;
      }
      .inner {
        animation: aaa 0.5s 0.9s ease-in-out;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/video/badge.vue